import { useCallback, useMemo, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppThunkDispatch } from 'state/store';
import { deleteUser as deleteUserAction } from 'state/UsersManagement/usersManagementSlice';
import { selectUserId } from 'state/User/userSlice';
import { PATHS, SETTINGS_TABS } from 'utils/constants';

export const useDeleteUser = () => {
  const { userId } = useParams<{ userId: string }>();
  const history = useHistory();
  const dispatch = useAppThunkDispatch();
  const currentUserId = useSelector(selectUserId);
  const [isDeleting, setIsDeleting] = useState(false);

  const isDeletingOwnAccount = useMemo(() => {
    return userId === currentUserId;
  }, [userId, currentUserId]);

  const deleteUser = useCallback(async () => {
    if (isDeletingOwnAccount) {
      return;
    }
    setIsDeleting(true);
    try {
      await dispatch(deleteUserAction(userId)).unwrap();
      history.push(`${PATHS.SETTINGS}/${SETTINGS_TABS.USERS}`);
    } catch (error) {
      setIsDeleting(false);
    }
  }, [userId, dispatch, isDeletingOwnAccount, history]);

  return { deleteUser, isDeleting, isDeletingOwnAccount };
};
